
import { InteractionStore } from "./interaction/InteractionStore";
import { AuthStore } from "./AuthStore";
import { SnackStore } from "./SnackStore";
import { ProfileStore } from "./ProfileStore";


/**
 * Stores
 */
export const snackStore = SnackStore.getInstance();
export const interactionStore = InteractionStore.getInstance();
export const profileStore = ProfileStore.getInstance();
export const authStore = AuthStore.getInstance();
